import React, { useState } from 'react';
import { FiFolder, FiPlus } from 'react-icons/fi';
import SettingsModal from '../../../clientSettings/SettingsModal';
import { FolderSort } from './docsData';

const SORTS: { value: FolderSort; title: string; hint: string }[] = [
    { value: 'newest', title: 'Newest first', hint: 'Good for reports and newsletters' },
    { value: 'manual', title: 'The order I choose', hint: 'Drag files to reorder' },
];

interface Props {
    onClose: () => void;
    onCreate: (name: string, description: string, sort: FolderSort) => void;
}

// New document folder (spec 410:12125)
const NewFolderModal: React.FC<Props> = ({ onClose, onCreate }) => {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [sort, setSort] = useState<FolderSort>('newest');

    return <SettingsModal icon={<FiFolder />} title="New Document Folder" sub="A folder is a list of files you can show anywhere on the website" onClose={onClose}
        footer={<button type="button" className="btn-primary with-icon" disabled={!name.trim()} onClick={() => onCreate(name.trim(), description.trim(), sort)}><FiPlus /> Create Folder</button>}>
        <label className="field">
            <span className="label">Folder name</span>
            <input value={name} placeholder="e.g. Annual reviews" autoFocus onChange={e => setName(e.target.value)} />
        </label>
        <label className="field">
            <span className="label">Short description<em>(optional) · shown above the list on the website</em></span>
            <input value={description} placeholder="e.g. Yearly environmental performance reports" onChange={e => setDescription(e.target.value)} />
        </label>
        <div className="field">
            <span className="label">How should files be sorted on the website?</span>
            <div className="options" role="radiogroup">
                {SORTS.map(s => <button key={s.value} type="button" role="radio" aria-checked={sort === s.value}
                    className={`option${sort === s.value ? ' selected' : ''}`} onClick={() => setSort(s.value)}>
                    <span className="radio" />
                    <span className="text"><strong>{s.title}</strong><span>{s.hint}</span></span>
                </button>)}
            </div>
        </div>
    </SettingsModal>;
};

export default NewFolderModal;
